export const blacklistedLoginPaths = [/^\/password-reset\//];
export const INTERNAL_SSO_ERROR_CODES = {
  userNotFound: 600,
  accountNotLinked: 601,
};
export const EBAY_SSO_ERROR_CODES = {
  suspended: 603,
  verificationFailed: 609,
  businessAccount: 610,
};
